import { isNil } from "../validation";

export const getPercentageValue = (value: number | string) => {
  const localValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNil(value) || Number.isNaN(localValue)) return "";

  return `${localValue.toFixed(2)}%`;
};
